import * as React from "react";
import { BackgroundImage } from '../library/BackgroundImage';
import { ComponentImage } from '../library/ComponentImage';

const COMPONENT_NAME = "YouTubeFrame";
const YOUTUBE_URL = "https://api.reddit.com/r/Bitcoin";
const cx = require('classNames');
// const gapi = require('gapi');

// gapi.server.setApiKey('AIzaSyD9LYQ-jBzZ3Oi1eQdE1HH-Ee3_Duti2P0');
// gapi.server.load('plus','v1',function(){
//     var request = gapi.server.plus.people.get({userId: '102147307918874735077'});
//     request.execute(function(resp){
//         res.writeHead(200, {'Content-Type': 'text/plain'});
//         res.end(JSON.stringify(resp));
//     });
// });

export class YouTubeFrame extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            selectedStory: '',
            hotStories: [],
            topStories: [],
            newStories: [],
            selectedTab: Tabs.HOT
        };

        // window.gapi.client.init({
        //     'apiKey': 'AIzaSyD9LYQ-jBzZ3Oi1eQdE1HH-Ee3_Duti2P0',
        //     // Your API key will be automatically added to the Discovery Document URLs.
        //     'discoveryDocs': ['https://people.googleapis.com/$discovery/rest'],
        // }).then(function() {
        //     // 3. Initialize and make the API request.
        //     return gapi.client.people.people.get({
        //         resourceName: 'people/me'
        //     });
        // }).then(function(response) {
        //     console.log(response.result);
        // }, function(reason) {
        //     console.log('Error: ' + reason.result.error.message);
        // });
    }

    render() {
        const { selectedStory } = this.state;
        const url = selectedStory ? 
            `https://reddit.com/${this.state.selectedStory.data.permalink}`:
            '';
        return (
            <div className="YouTubeFrame">
                
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./react/components/YouTubeFrame.jsx